<div class="w-full mx-auto min-h-screen p-5 bg-gray-50 dark:bg-gray-900">
  <!-- Header Section -->
  <div class="mb-8">
    <div class="text-center mb-8">
      <h1 class="text-4xl font-bold text-gray-900 dark:text-white mb-3 flex items-center justify-center">
        <svg class="h-8 w-8 text-blue-600 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
        </svg>
        Crear Nuevo Proyecto
      </h1>
      <p class="text-gray-600 dark:text-gray-300">Configura tu proyecto paso a paso con nuestro asistente inteligente
      </p>
    </div>

    <!-- Modern Stepper -->
    <div class="flex justify-center mb-12">
      <div class="flex items-center space-x-8">
        <!-- Step 1 -->
        <div class="flex items-center group">
          <div class="relative">
            <div class="flex items-center justify-center w-12 h-12 rounded-full shadow-lg transition-all duration-300"
              [ngClass]="{
                   'bg-gradient-to-br from-blue-500 to-blue-600 text-white': currentStep >= 1,
                   'bg-gray-200 text-gray-500 dark:bg-gray-700 dark:text-gray-400': currentStep < 1
                 }">
              <svg *ngIf="currentStep > 1" class="h-6 w-6" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clip-rule="evenodd" />
              </svg>
              <span *ngIf="currentStep <= 1" class="font-bold text-lg">1</span>
            </div>
            <div *ngIf="currentStep === 1"
              class="absolute -inset-1 bg-blue-400 rounded-full blur opacity-75 animate-pulse"></div>
          </div>
          <div class="ml-4">
            <p class="font-medium text-gray-900 dark:text-white">Información Básica</p>
            <p class="text-sm text-gray-500 dark:text-gray-400">Datos generales del proyecto</p>
          </div>
        </div>

        <!-- Connector Line -->
        <div class="hidden sm:block w-16 h-0.5 transition-all duration-500" [ngClass]="{
               'bg-gradient-to-r from-blue-500 to-blue-600': currentStep > 1,
               'bg-gray-300 dark:bg-gray-600': currentStep <= 1
             }"></div>

        <!-- Step 2 -->
        <div class="flex items-center group">
          <div class="relative">
            <div class="flex items-center justify-center w-12 h-12 rounded-full shadow-lg transition-all duration-300"
              [ngClass]="{
                   'bg-gradient-to-br from-green-500 to-green-600 text-white': currentStep >= 2,
                   'bg-gray-200 text-gray-500 dark:bg-gray-700 dark:text-gray-400': currentStep < 2
                 }">
              <svg *ngIf="currentStep > 2" class="h-6 w-6" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clip-rule="evenodd" />
              </svg>
              <span *ngIf="currentStep <= 2" class="font-bold text-lg">2</span>
            </div>
            <div *ngIf="currentStep === 2"
              class="absolute -inset-1 bg-green-400 rounded-full blur opacity-75 animate-pulse"></div>
          </div>
          <div class="ml-4">
            <p class="font-medium text-gray-900 dark:text-white">Proyecciones</p>
            <p class="text-sm text-gray-500 dark:text-gray-400">Ingresos y gastos estimados</p>
          </div>
        </div>

        <!-- Connector Line -->
        <div class="hidden sm:block w-16 h-0.5 transition-all duration-500" [ngClass]="{
               'bg-gradient-to-r from-green-500 to-green-600': currentStep > 2,
               'bg-gray-300 dark:bg-gray-600': currentStep <= 2
             }"></div>

        <!-- Step 3 -->
        <div class="flex items-center group">
          <div class="relative">
            <div class="flex items-center justify-center w-12 h-12 rounded-full shadow-lg transition-all duration-300"
              [ngClass]="{
                   'bg-gradient-to-br from-purple-500 to-purple-600 text-white': currentStep >= 3,
                   'bg-gray-200 text-gray-500 dark:bg-gray-700 dark:text-gray-400': currentStep < 3
                 }">
              <svg class="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <div *ngIf="currentStep === 3"
              class="absolute -inset-1 bg-purple-400 rounded-full blur opacity-75 animate-pulse"></div>
          </div>
          <div class="ml-4">
            <p class="font-medium text-gray-900 dark:text-white">Presupuestos</p>
            <p class="text-sm text-gray-500 dark:text-gray-400">Configuración detallada</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <form [formGroup]="projectForm" (ngSubmit)="onSubmit()">

    <!-- STEP 1: Información Básica -->
    <div *ngIf="currentStep === 1" class="animate-fade-in">
      <!-- Contenedor principal -->
      <div class="rounded-2xl border-2 border-blue-100 bg-white p-8 shadow-lg dark:border-blue-800/30 dark:bg-gray-800">
        <div class="mb-8 text-center">
          <div
            class="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-blue-100 border-2 border-blue-200 shadow-lg dark:bg-blue-900/20 dark:border-blue-700">
            <svg class="h-8 w-8 text-blue-600 dark:text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <h2 class="text-2xl font-bold text-gray-900 dark:text-white">Información Básica del Proyecto</h2>
          <p class="mt-2 text-gray-600 dark:text-gray-300">Completa los datos esenciales de tu proyecto</p>
        </div>

        <!-- Grid de campos -->
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">

          <!-- Información General Card -->
          <div
            class="group rounded-xl border-2 border-blue-100 bg-white p-6 shadow-sm transition-all duration-300 hover:shadow-md hover:border-blue-200 dark:border-blue-800/30 dark:bg-gray-800 dark:hover:border-blue-700/50">
            <div class="mb-4 flex items-center">
              <div class="mr-3 flex h-10 w-10 items-center justify-center rounded-lg bg-blue-100 dark:bg-blue-900/20">
                <svg class="h-5 w-5 text-blue-600 dark:text-blue-400" fill="none" stroke="currentColor"
                  viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
                </svg>
              </div>
              <h3 class="text-lg font-semibold text-gray-900 dark:text-white">Información General</h3>
            </div>

            <!-- Nombre del Proyecto -->
            <div class="mb-6">
              <label for="name" class="mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300"
                appRequiredLabel>
                Nombre del Proyecto
              </label>
              <input type="text" id="name" formControlName="name"
                class="w-full rounded-lg border border-gray-300 bg-white px-4 py-3 text-gray-900 placeholder-gray-500 shadow-sm transition-all duration-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 dark:border-gray-600 dark:bg-gray-800 dark:text-white dark:placeholder-gray-400"
                placeholder="Ej: Diplomado en Gestión Empresarial">
              <div *ngIf="projectForm.get('name')?.invalid && projectForm.get('name')?.touched"
                class="mt-2 flex items-center text-sm text-red-600 dark:text-red-400">
                <svg class="mr-2 h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd"
                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                    clip-rule="evenodd" />
                </svg>
                El nombre es obligatorio.
              </div>
            </div>

            <!-- Nemónico del Proyecto -->
            <div class="mb-6">
              <label for="projectId" class="mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300"
                appRequiredLabel>
                Nemónico del Proyecto
              </label>
              <input type="text" id="projectId" (blur)="checkDuplicity($event)" formControlName="projectId"
                class="w-full rounded-lg border border-gray-300 bg-white px-4 py-3 text-gray-900 placeholder-gray-500 shadow-sm transition-all duration-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 dark:border-gray-600 dark:bg-gray-800 dark:text-white dark:placeholder-gray-400"
                [class.border-red-300]="projectIdExists" placeholder="Ej: DGE2024">
              <div *ngIf="projectForm.get('projectId')?.invalid && projectForm.get('projectId')?.touched"
                class="mt-2 flex items-center text-sm text-red-600 dark:text-red-400">
                <svg class="mr-2 h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd"
                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                    clip-rule="evenodd" />
                </svg>
                El Nemónico es obligatorio.
              </div>
              <div *ngIf="projectIdExists" class="mt-2 flex items-center text-sm text-red-600 dark:text-red-400">
                <svg class="mr-2 h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd"
                    d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                    clip-rule="evenodd" />
                </svg>
                Ya existe un proyecto con este nemónico.
              </div>
            </div>

            <!-- Descripción -->
            <div class="mb-0">
              <label for="description" class="mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300">
                Descripción
              </label>
              <textarea id="description" formControlName="description" rows="4"
                class="w-full rounded-lg border border-gray-300 bg-white px-4 py-3 text-gray-900 placeholder-gray-500 shadow-sm transition-all duration-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 dark:border-gray-600 dark:bg-gray-800 dark:text-white dark:placeholder-gray-400"
                placeholder="Describe brevemente el alcance y objetivos del proyecto..."></textarea>
            </div>
          </div>

          <!-- Configuración de Moneda Card -->
          <div
            class="group rounded-xl border-2 border-blue-100 bg-white p-6 shadow-sm transition-all duration-300 hover:shadow-md hover:border-blue-200 dark:border-blue-800/30 dark:bg-gray-800 dark:hover:border-blue-700/50">
            <div class="mb-4 flex items-center">
              <div class="mr-3 flex h-10 w-10 items-center justify-center rounded-lg bg-blue-50 dark:bg-blue-900/20">
                <svg class="h-5 w-5 text-blue-600 dark:text-blue-400" fill="none" stroke="currentColor"
                  viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 class="text-lg font-semibold text-gray-900 dark:text-white">Configuración Monetaria</h3>
            </div>

            <!-- Selector de Moneda -->
            <div class="mb-6">
              <label for="currencyId" class="mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300"
                appRequiredLabel>
                Moneda del Proyecto
              </label>
              <div class="relative">
                <select id="currencyId" formControlName="currencyId"
                  class="w-full rounded-lg border border-gray-300 bg-white px-4 py-3 text-gray-900 shadow-sm transition-all duration-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 dark:border-gray-600 dark:bg-gray-800 dark:text-white">
                  <option value="" disabled>Seleccione una moneda</option>
                  <option *ngFor="let currency of currencies" [value]="currency.id">
                    {{ getCurrencyDisplayName(currency) }}
                  </option>
                </select>
                <div
                  class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 dark:text-gray-300">
                  <svg class="h-4 w-4 fill-current" viewBox="0 0 20 20">
                    <path
                      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
                  </svg>
                </div>
              </div>

              <div class="mt-2 flex items-center" *ngIf="loadingCurrencies">
                <div class="mr-2 h-4 w-4 animate-spin rounded-full border-b-2 border-blue-500"></div>
                <span class="text-sm text-gray-500 dark:text-gray-400">Cargando monedas...</span>
              </div>

              <p class="mt-2 text-sm text-gray-500 dark:text-gray-400" *ngIf="!loadingCurrencies">
                💡 Selecciona la moneda base para este proyecto
              </p>

              <div *ngIf="projectForm.get('currencyId')?.invalid && projectForm.get('currencyId')?.touched"
                class="mt-2 flex items-center text-sm text-red-600 dark:text-red-400">
                <svg class="mr-2 h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd"
                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                    clip-rule="evenodd" />
                </svg>
                La moneda es obligatoria.
              </div>
            </div>

            <!-- Montos de Inscripción -->
            <div class="space-y-4">
              <!-- Monto COP -->
              <div>
                <label for="inscriptionAmountCOP"
                  class="mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300" appRequiredLabel>
                  Inscripción en COP
                </label>
                <div class="relative">
                  <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                    <span class="text-gray-500 dark:text-gray-400">$</span>
                  </div>
                  <input type="text" appCurrencyFormatter id="inscriptionAmountCOP"
                    formControlName="inscriptionAmountCOP"
                    class="w-full rounded-lg border border-gray-300 bg-white pl-8 pr-4 py-3 text-gray-900 placeholder-gray-500 shadow-sm transition-all duration-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 dark:border-gray-600 dark:bg-gray-800 dark:text-white dark:placeholder-gray-400"
                    placeholder="0">
                </div>
                <div
                  *ngIf="projectForm.get('inscriptionAmountCOP')?.invalid && projectForm.get('inscriptionAmountCOP')?.touched"
                  class="mt-2 flex items-center text-sm text-red-600 dark:text-red-400">
                  <svg class="mr-2 h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd"
                      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                      clip-rule="evenodd" />
                  </svg>
                  Monto de Inscripción en COP es obligatorio.
                </div>
              </div>

              <!-- Monto USD -->
              <div>
                <label for="inscriptionAmountUSD"
                  class="mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300" appRequiredLabel>
                  Inscripción en USD
                </label>
                <div class="relative">
                  <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                    <span class="text-gray-500 dark:text-gray-400">$</span>
                  </div>
                  <input type="text" appCurrencyFormatter id="inscriptionAmountUSD"
                    formControlName="inscriptionAmountUSD"
                    class="w-full rounded-lg border border-gray-300 bg-white pl-8 pr-4 py-3 text-gray-900 placeholder-gray-500 shadow-sm transition-all duration-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 dark:border-gray-600 dark:bg-gray-800 dark:text-white dark:placeholder-gray-400"
                    placeholder="0.00">
                </div>
                <div
                  *ngIf="projectForm.get('inscriptionAmountUSD')?.invalid && projectForm.get('inscriptionAmountUSD')?.touched"
                  class="mt-2 flex items-center text-sm text-red-600 dark:text-red-400">
                  <svg class="mr-2 h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd"
                      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                      clip-rule="evenodd" />
                  </svg>
                  Monto de Inscripción en USD es obligatorio.
                </div>
              </div>
            </div>
          </div>

          <!-- Configuración de Proyecto Card -->
          <div
            class="group rounded-xl border-2 border-blue-100 bg-white p-6 shadow-sm transition-all duration-300 hover:shadow-md hover:border-blue-200 dark:border-blue-800/30 dark:bg-gray-800 dark:hover:border-blue-700/50">
            <div class="mb-4 flex items-center">
              <div class="mr-3 flex h-10 w-10 items-center justify-center rounded-lg bg-blue-50 dark:bg-blue-900/20">
                <svg class="h-5 w-5 text-blue-600 dark:text-blue-400" fill="none" stroke="currentColor"
                  viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
                </svg>
              </div>
              <h3 class="text-lg font-semibold text-gray-900 dark:text-white">Configuración del Proyecto</h3>
            </div>

            <div class="space-y-4">
              <!-- Período -->
              <div>
                <label for="period" class="mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300"
                  appRequiredLabel>
                  Período
                </label>
                <p-dropdown id="period" formControlName="period" [options]="months" optionLabel="label"
                  optionValue="value" placeholder="Seleccione un mes" styleClass="w-full"
                  inputStyleClass="w-full rounded-lg border border-gray-300 bg-white px-4 py-3 text-gray-900 placeholder-gray-500 shadow-sm transition-all duration-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 dark:border-gray-600 dark:bg-gray-800 dark:text-white dark:placeholder-gray-400"
                  [appendTo]="'body'">
                </p-dropdown>
                <div *ngIf="projectForm.get('period')?.invalid && projectForm.get('period')?.touched"
                  class="mt-2 flex items-center text-sm text-red-600 dark:text-red-400">
                  <svg class="mr-2 h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd"
                      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                      clip-rule="evenodd" />
                  </svg>
                  Período es obligatorio
                </div>
              </div>

              <!-- Estado -->
              <div>
                <label for="status" class="mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300"
                  appRequiredLabel>
                  Estado del Proyecto
                </label>
                <div class="relative">
                  <select id="status" formControlName="status"
                    class="w-full rounded-lg border border-gray-300 bg-white px-4 py-3 text-gray-900 shadow-sm transition-all duration-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 dark:border-gray-600 dark:bg-gray-800 dark:text-white">
                    <option value="" disabled>Seleccione un estado</option>
                    <option *ngFor="let type of projectStatus" [value]="type.value">{{ type.label }}</option>
                  </select>
                  <div
                    class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 dark:text-gray-300">
                    <svg class="h-4 w-4 fill-current" viewBox="0 0 20 20">
                      <path
                        d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
                    </svg>
                  </div>
                </div>
                <div *ngIf="projectForm.get('status')?.invalid && projectForm.get('status')?.touched"
                  class="mt-2 flex items-center text-sm text-red-600 dark:text-red-400">
                  <svg class="mr-2 h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd"
                      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                      clip-rule="evenodd" />
                  </svg>
                  Estado es obligatorio
                </div>
              </div>

              <!-- Tipo de Proyecto -->
              <div>
                <label for="typeProject" class="mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300"
                  appRequiredLabel>
                  Tipo de Proyecto
                </label>
                <div class="relative">
                  <select id="typeProject" formControlName="typeProject"
                    class="w-full rounded-lg border border-gray-300 bg-white px-4 py-3 text-gray-900 shadow-sm transition-all duration-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 dark:border-gray-600 dark:bg-gray-800 dark:text-white">
                    <option value="" disabled>Seleccione un tipo</option>
                    <option *ngFor="let type of projectTypes" [value]="type.value">{{ type.label }}</option>
                  </select>
                  <div
                    class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 dark:text-gray-300">
                    <svg class="h-4 w-4 fill-current" viewBox="0 0 20 20">
                      <path
                        d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
                    </svg>
                  </div>
                </div>
                <div *ngIf="projectForm.get('typeProject')?.invalid && projectForm.get('typeProject')?.touched"
                  class="mt-2 flex items-center text-sm text-red-600 dark:text-red-400">
                  <svg class="mr-2 h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd"
                      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                      clip-rule="evenodd" />
                  </svg>
                  Tipo de proyecto es obligatorio.
                </div>
              </div>
            </div>
          </div>

          <!-- Fechas y Duración Card -->
          <div
            class="group rounded-xl border-2 border-blue-100 bg-white p-6 shadow-sm transition-all duration-300 hover:shadow-md hover:border-blue-200 dark:border-blue-800/30 dark:bg-gray-800 dark:hover:border-blue-700/50">
            <div class="mb-4 flex items-center">
              <div class="mr-3 flex h-10 w-10 items-center justify-center rounded-lg bg-blue-50 dark:bg-blue-900/20">
                <svg class="h-5 w-5 text-blue-600 dark:text-blue-400" fill="none" stroke="currentColor"
                  viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
              </div>
              <h3 class="text-lg font-semibold text-gray-900 dark:text-white">Fechas y Duración</h3>
            </div>

            <div class="space-y-4">
              <!-- Fecha de Inicio -->
              <div>
                <label for="date" class="mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300"
                  appRequiredLabel>
                  Fecha de Inicio
                </label>
                <p-calendar id="date" formControlName="date" dateFormat="dd/mm/yy" [showIcon]="true"
                  [iconDisplay]="'input'" placeholder="Selecciona fecha de inicio" styleClass="w-full"
                  inputStyleClass="w-full rounded-lg border border-gray-300 bg-white px-4 py-3 text-gray-900 placeholder-gray-500 shadow-sm transition-all duration-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 dark:border-gray-600 dark:bg-gray-800 dark:text-white dark:placeholder-gray-400"
                  [appendTo]="'body'">
                </p-calendar>
                <div *ngIf="projectForm.get('date')?.invalid && projectForm.get('date')?.touched"
                  class="mt-2 flex items-center text-sm text-red-600 dark:text-red-400">
                  <svg class="mr-2 h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd"
                      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                      clip-rule="evenodd" />
                  </svg>
                  Fecha de Inicio es obligatorio
                </div>
              </div>

              <!-- Fecha de Cierre -->
              <div>
                <label for="dateClosed" class="mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300"
                  appRequiredLabel>
                  Fecha de Cierre
                </label>
                <p-calendar id="dateClosed" formControlName="dateClosed" dateFormat="dd/mm/yy" [showIcon]="true"
                  [iconDisplay]="'input'" placeholder="Selecciona fecha de cierre" styleClass="w-full"
                  inputStyleClass="w-full rounded-lg border border-gray-300 bg-white px-4 py-3 text-gray-900 placeholder-gray-500 shadow-sm transition-all duration-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 dark:border-gray-600 dark:bg-gray-800 dark:text-white dark:placeholder-gray-400"
                  [appendTo]="'body'">
                </p-calendar>
                <div *ngIf="projectForm.get('dateClosed')?.invalid && projectForm.get('dateClosed')?.touched"
                  class="mt-2 flex items-center text-sm text-red-600 dark:text-red-400">
                  <svg class="mr-2 h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd"
                      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                      clip-rule="evenodd" />
                  </svg>
                  La Fecha de cierre es obligatorio.
                </div>
              </div>

              <!-- Duración -->
              <div>
                <label for="duration" class="mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300"
                  appRequiredLabel>
                  Duración (semanas)
                </label>
                <div class="relative">
                  <input type="number" id="duration" formControlName="duration"
                    class="w-full rounded-lg border border-gray-300 bg-white px-4 py-3 text-gray-900 placeholder-gray-500 shadow-sm transition-all duration-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 dark:border-gray-600 dark:bg-gray-800 dark:text-white dark:placeholder-gray-400"
                    placeholder="Ej: 12" min="1">
                  <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
                    <span class="text-sm text-gray-500 dark:text-gray-400">semanas</span>
                  </div>
                </div>
                <div *ngIf="projectForm.get('duration')?.invalid && projectForm.get('duration')?.touched"
                  class="mt-2 flex items-center text-sm text-red-600 dark:text-red-400">
                  <svg class="mr-2 h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd"
                      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                      clip-rule="evenodd" />
                  </svg>
                  Duración en semanas es obligatorio.
                </div>
              </div>

              <!-- Participantes Proyectados -->
              <div>
                <label for="projectedParticipants"
                  class="mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300" appRequiredLabel>
                  Participantes Proyectados
                </label>
                <div class="relative">
                  <input type="number" id="projectedParticipants" formControlName="projectedParticipants"
                    class="w-full rounded-lg border border-gray-300 bg-white px-4 py-3 text-gray-900 placeholder-gray-500 shadow-sm transition-all duration-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 dark:border-gray-600 dark:bg-gray-800 dark:text-white dark:placeholder-gray-400"
                    placeholder="Ej: 25" min="0">
                  <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
                    <svg class="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                    </svg>
                  </div>
                </div>
                <div
                  *ngIf="projectForm.get('projectedParticipants')?.invalid && projectForm.get('projectedParticipants')?.touched"
                  class="mt-2 flex items-center text-sm text-red-600 dark:text-red-400">
                  <svg class="mr-2 h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd"
                      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                      clip-rule="evenodd" />
                  </svg>
                  Participantes proyectados es obligatorio.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- STEP 2: Proyecciones Financieras -->
    <div *ngIf="currentStep === 2" class="animate-fade-in">
      <!-- Contenedor principal -->
      <div class="rounded-2xl border-2 border-blue-100 bg-white p-8 shadow-lg dark:border-blue-800/30 dark:bg-gray-800">
        <div class="mb-8 text-center">
          <div
            class="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-blue-100 border-2 border-blue-200 shadow-lg dark:bg-blue-900/20 dark:border-blue-700">
            <svg class="h-8 w-8 text-blue-600 dark:text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
            </svg>
          </div>
          <h2 class="text-2xl font-bold text-gray-900 dark:text-white">Proyecciones Financieras</h2>
          <p class="mt-2 text-gray-600 dark:text-gray-300">Define los ingresos y gastos esperados para tu proyecto</p>
        </div>

        <!-- Grid de proyecciones -->
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8">

          <!-- Proyecciones de Ingresos Card -->
          <div
            class="group rounded-xl border-2 border-blue-100 bg-white p-6 shadow-sm transition-all duration-300 hover:shadow-md hover:border-blue-200 dark:border-blue-800/30 dark:bg-gray-800 dark:hover:border-blue-700/50">
            <div class="mb-6 flex items-center">
              <div
                class="mr-4 flex h-12 w-12 items-center justify-center rounded-lg bg-blue-50 shadow-sm dark:bg-blue-900/20">
                <svg class="h-6 w-6 text-blue-600 dark:text-blue-400" fill="none" stroke="currentColor"
                  viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
                </svg>
              </div>
              <div>
                <h3 class="text-xl font-semibold text-gray-900 dark:text-white">Ingresos Proyectados</h3>
                <p class="text-sm text-gray-600 dark:text-gray-300">Estima los ingresos totales esperados</p>
              </div>
            </div>

            <div class="space-y-4">
              <div>
                <label for="projectedRevenue" class="mb-3 block text-sm font-medium text-gray-700 dark:text-gray-300"
                  appRequiredLabel>
                  Total de Ingresos Esperados
                </label>
                <div class="relative">
                  <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-4">
                    <svg class="h-5 w-5 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  <input type="text" appCurrencyFormatter id="projectedRevenue" formControlName="projectedRevenue"
                    class="w-full rounded-lg border border-green-200 bg-white pl-12 pr-4 py-4 text-lg font-medium text-gray-900 placeholder-gray-500 shadow-sm transition-all duration-200 focus:border-green-500 focus:ring-2 focus:ring-green-500/20 dark:border-green-700 dark:bg-gray-800 dark:text-white dark:placeholder-gray-400"
                    placeholder="0">
                </div>

                <div
                  class="mt-3 rounded-lg bg-blue-50 border border-blue-100 p-4 dark:bg-blue-900/10 dark:border-blue-800/30">
                  <div class="flex items-start">
                    <svg class="mr-2 mt-0.5 h-4 w-4 text-blue-600 dark:text-blue-400" fill="currentColor"
                      viewBox="0 0 20 20">
                      <path fill-rule="evenodd"
                        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                        clip-rule="evenodd" />
                    </svg>
                    <div class="text-sm text-blue-800 dark:text-blue-200">
                      <p class="font-medium mb-1">💡 Consejos para calcular ingresos:</p>
                      <ul class="space-y-1 text-xs">
                        <li>• Considera inscripciones + certificaciones</li>
                        <li>• Incluye posibles patrocinios o apoyos</li>
                        <li>• Revisa proyectos similares anteriores</li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div
                  *ngIf="projectForm.get('projectedRevenue')?.invalid && projectForm.get('projectedRevenue')?.touched"
                  class="mt-3 flex items-center text-sm text-red-600 dark:text-red-400">
                  <svg class="mr-2 h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd"
                      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                      clip-rule="evenodd" />
                  </svg>
                  Los ingresos proyectados deben ser 0 o mayor.
                </div>
              </div>
            </div>
          </div>

          <!-- Proyecciones de Gastos Card -->
          <div
            class="group rounded-xl border-2 border-blue-100 bg-white p-6 shadow-sm transition-all duration-300 hover:shadow-md hover:border-blue-200 dark:border-blue-800/30 dark:bg-gray-800 dark:hover:border-blue-700/50">
            <div class="mb-6 flex items-center">
              <div
                class="mr-4 flex h-12 w-12 items-center justify-center rounded-lg bg-blue-50 shadow-sm dark:bg-blue-900/20">
                <svg class="h-6 w-6 text-blue-600 dark:text-blue-400" fill="none" stroke="currentColor"
                  viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M19 14l-7 7m0 0l-7-7m7 7V3" />
                </svg>
              </div>
              <div>
                <h3 class="text-xl font-semibold text-gray-900 dark:text-white">Gastos Proyectados</h3>
                <p class="text-sm text-gray-600 dark:text-gray-300">Presupuesta los gastos totales necesarios</p>
              </div>
            </div>

            <div class="space-y-4">
              <div>
                <label for="projectedSpend" class="mb-3 block text-sm font-medium text-gray-700 dark:text-gray-300"
                  appRequiredLabel>
                  Total de Gastos Estimados
                </label>
                <div class="relative">
                  <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-4">
                    <svg class="h-5 w-5 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  <input type="text" appCurrencyFormatter id="projectedSpend" formControlName="projectedSpend"
                    class="w-full rounded-lg border border-red-200 bg-white pl-12 pr-4 py-4 text-lg font-medium text-gray-900 placeholder-gray-500 shadow-sm transition-all duration-200 focus:border-red-500 focus:ring-2 focus:ring-red-500/20 dark:border-red-700 dark:bg-gray-800 dark:text-white dark:placeholder-gray-400"
                    placeholder="0">
                </div>

                <div
                  class="mt-3 rounded-lg bg-blue-50 border border-blue-100 p-4 dark:bg-blue-900/10 dark:border-blue-800/30">
                  <div class="flex items-start">
                    <svg class="mr-2 mt-0.5 h-4 w-4 text-blue-600 dark:text-blue-400" fill="currentColor"
                      viewBox="0 0 20 20">
                      <path fill-rule="evenodd"
                        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                        clip-rule="evenodd" />
                    </svg>
                    <div class="text-sm text-blue-800 dark:text-blue-200">
                      <p class="font-medium mb-1">📝 Elementos a considerar:</p>
                      <ul class="space-y-1 text-xs">
                        <li>• Personal docente y administrativo</li>
                        <li>• Material didáctico y tecnología</li>
                        <li>• Logística, transporte, alimentación</li>
                        <li>• Certificaciones y gastos administrativos</li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div *ngIf="projectForm.get('projectedSpend')?.invalid && projectForm.get('projectedSpend')?.touched"
                  class="mt-3 flex items-center text-sm text-red-600 dark:text-red-400">
                  <svg class="mr-2 h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd"
                      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                      clip-rule="evenodd" />
                  </svg>
                  El gasto proyectado debe ser 0 o mayor.
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Resumen Financiero -->
        <div class="rounded-xl border-2 border-blue-100 bg-white p-6 dark:border-blue-800/30 dark:bg-gray-800">
          <div class="text-center">
            <h3 class="mb-4 text-lg font-semibold text-gray-900 dark:text-white flex items-center justify-center">
              <svg class="mr-2 h-5 w-5 text-blue-600 dark:text-blue-400" fill="none" stroke="currentColor"
                viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v4" />
              </svg>
              Proyección Financiera
            </h3>

            <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div class="rounded-lg bg-white p-4 shadow-sm dark:bg-gray-800">
                <p class="text-sm font-medium text-green-600 dark:text-green-400">Ingresos Proyectados</p>
                <p class="mt-1 text-xl font-bold text-gray-900 dark:text-white">
                  {{ (projectForm.get('projectedRevenue')?.value || 0) | currency }}
                </p>
              </div>

              <div class="rounded-lg bg-white p-4 shadow-sm dark:bg-gray-800">
                <p class="text-sm font-medium text-red-600 dark:text-red-400">Gastos Proyectados</p>
                <p class="mt-1 text-xl font-bold text-gray-900 dark:text-white">
                  {{ (projectForm.get('projectedSpend')?.value || 0) | currency }}
                </p>
              </div>

              <div class="rounded-lg bg-white p-4 shadow-sm dark:bg-gray-800">
                <p class="text-sm font-medium" [ngClass]="{
                'text-green-600 dark:text-green-400': (projectForm.get('projectedRevenue')?.value || 0) - (projectForm.get('projectedSpend')?.value || 0) >= 0,
                'text-red-600 dark:text-red-400': (projectForm.get('projectedRevenue')?.value || 0) - (projectForm.get('projectedSpend')?.value || 0) < 0
              }">Margen Proyectado</p>
                <p class="mt-1 text-xl font-bold" [ngClass]="{
                'text-green-600 dark:text-green-400': (projectForm.get('projectedRevenue')?.value || 0) - (projectForm.get('projectedSpend')?.value || 0) >= 0,
                'text-red-600 dark:text-red-400': (projectForm.get('projectedRevenue')?.value || 0) - (projectForm.get('projectedSpend')?.value || 0) < 0
              }">
                  {{ ((projectForm.get('projectedRevenue')?.value || 0) - (projectForm.get('projectedSpend')?.value ||
                  0)) | currency }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- Observaciones Card -->
        <div
          class="mt-8 rounded-xl border-2 border-blue-100 bg-white p-6 shadow-sm transition-all duration-300 hover:shadow-md hover:border-blue-200 dark:border-blue-800/30 dark:bg-gray-800 dark:hover:border-blue-700/50">
          <div class="mb-4 flex items-center">
            <div class="mr-3 flex h-10 w-10 items-center justify-center rounded-lg bg-blue-50 dark:bg-blue-900/20">
              <svg class="h-5 w-5 text-blue-600 dark:text-blue-400" fill="none" stroke="currentColor"
                viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
              </svg>
            </div>
            <div>
              <h3 class="text-lg font-semibold text-gray-900 dark:text-white">Observaciones y Notas</h3>
              <p class="text-sm text-gray-600 dark:text-gray-300">Información adicional sobre las proyecciones</p>
            </div>
          </div>

          <div>
            <label for="observations" class="mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300">
              Comentarios adicionales
            </label>
            <textarea id="observations" formControlName="observations" rows="4"
              class="w-full rounded-lg border border-gray-300 bg-white px-4 py-3 text-gray-900 placeholder-gray-500 shadow-sm transition-all duration-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 dark:border-gray-600 dark:bg-gray-800 dark:text-white dark:placeholder-gray-400"
              placeholder="Agrega cualquier información relevante sobre las proyecciones financieras, metodología utilizada, supuestos considerados, etc."></textarea>
          </div>
        </div>
      </div>
    </div>
    <!-- STEP 3: Configuración de Presupuestos -->
    <div *ngIf="currentStep === 3" class="animate-fade-in">
      <!-- Contenedor principal -->
      <div class="rounded-2xl border-2 border-blue-100 bg-white p-8 shadow-lg dark:border-blue-800/30 dark:bg-gray-800">
        <div class="mb-8 text-center">
          <div
            class="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-blue-100 border-2 border-blue-200 shadow-lg dark:bg-blue-900/20 dark:border-blue-700">
            <svg class="h-8 w-8 text-blue-600 dark:text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <h2 class="text-2xl font-bold text-gray-900 dark:text-white">Configuración de Presupuestos</h2>
          <p class="mt-2 text-gray-600 dark:text-gray-300">Define las categorías y montos específicos del proyecto</p>
        </div>

        <div formArrayName="budgets">
          <!-- Cards de presupuesto en lugar de tabla -->
          <div class="space-y-6 mb-8">
            <ng-container *ngFor="let itemForm of budgets.controls; let i = index">
              <div formGroupName="{{ i }}"
                class="group relative rounded-xl border-2 border-blue-100 bg-white p-6 shadow-sm transition-all duration-300 hover:shadow-md hover:border-blue-200 dark:border-blue-800/30 dark:bg-gray-800 dark:hover:border-blue-700/50">

                <!-- Header de la card con número -->
                <div class="mb-6 flex items-center justify-between">
                  <div class="flex items-center">
                    <div
                      class="mr-4 flex h-10 w-10 items-center justify-center rounded-lg bg-blue-50 shadow-sm dark:bg-blue-900/20">
                      <span class="font-bold text-blue-600 dark:text-blue-400">{{ i + 1 }}</span>
                    </div>
                    <div>
                      <h3 class="text-lg font-semibold text-gray-900 dark:text-white">Presupuesto {{ i + 1 }}</h3>
                      <p class="text-sm text-gray-600 dark:text-gray-300">Configuración de categoría presupuestal</p>
                    </div>
                  </div>

                  <!-- Botón eliminar con estilo moderno -->
                  <button type="button" (click)="removeItem(i)" *ngIf="budgets.controls.length > 1"
                    class="group/btn relative inline-flex items-center justify-center p-2 rounded-lg border border-red-200 bg-red-50 text-red-600 shadow-sm transition-all duration-200 hover:bg-red-100 hover:border-red-300 hover:shadow-md focus:outline-none focus:ring-2 focus:ring-red-500/20 dark:border-red-800/50 dark:bg-red-900/20 dark:text-red-400 dark:hover:bg-red-900/40"
                    title="Eliminar presupuesto">
                    <svg class="h-5 w-5 transition-transform duration-200 group-hover/btn:scale-110" fill="none"
                      stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                    </svg>
                  </button>
                </div>

                <!-- Grid de campos -->
                <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">

                  <!-- Categoría -->
                  <div class="space-y-4">
                    <div>
                      <label for="budgetCategoryId"
                        class="mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300" appRequiredLabel>
                        Categoría de Presupuesto
                      </label>
                      <div class="relative">
                        <select id="budgetCategoryId" formControlName="budgetCategoryId"
                          class="w-full rounded-lg border border-gray-300 bg-white px-4 py-3 text-gray-900 shadow-sm transition-all duration-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 dark:border-gray-600 dark:bg-gray-800 dark:text-white">
                          <option value="" disabled>Seleccione una categoría</option>
                          <option *ngFor="let category of categories" [value]="category.id">
                            {{ category.name }} ({{ getBudgetTypeName(category.budgetType) }})
                          </option>
                        </select>
                        <div
                          class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 dark:text-gray-300">
                          <svg class="h-4 w-4 fill-current" viewBox="0 0 20 20">
                            <path
                              d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
                          </svg>
                        </div>
                      </div>
                      <div
                        *ngIf="itemForm.get('budgetCategoryId')?.invalid && itemForm.get('budgetCategoryId')?.touched"
                        class="mt-2 flex items-center text-sm text-red-600 dark:text-red-400">
                        <svg class="mr-2 h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
                          <path fill-rule="evenodd"
                            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                            clip-rule="evenodd" />
                        </svg>
                        La categoría es obligatoria.
                      </div>
                    </div>

                    <!-- Subcategoría -->
                    <div>
                      <label for="budgetSubcategoryId"
                        class="mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300" appRequiredLabel>
                        Subcategoría
                      </label>
                      <div class="relative">
                        <select id="budgetSubcategoryId" formControlName="budgetSubcategoryId"
                          (change)="loadProjectedAmount($event, i)"
                          class="w-full rounded-lg border border-gray-300 bg-white px-4 py-3 text-gray-900 shadow-sm transition-all duration-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 dark:border-gray-600 dark:bg-gray-800 dark:text-white">
                          <option value="" disabled>Seleccione una subcategoría</option>
                          <option *ngFor="let subcategory of getSubcategories(itemForm.get('budgetCategoryId')?.value)"
                            [value]="subcategory.id">
                            {{ subcategory.name }}
                          </option>
                        </select>
                        <div
                          class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 dark:text-gray-300">
                          <svg class="h-4 w-4 fill-current" viewBox="0 0 20 20">
                            <path
                              d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
                          </svg>
                        </div>
                      </div>
                      <div
                        *ngIf="itemForm.get('budgetSubcategoryId')?.invalid && itemForm.get('budgetSubcategoryId')?.touched"
                        class="mt-2 flex items-center text-sm text-red-600 dark:text-red-400">
                        <svg class="mr-2 h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
                          <path fill-rule="evenodd"
                            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                            clip-rule="evenodd" />
                        </svg>
                        La subcategoría es obligatoria.
                      </div>
                    </div>
                  </div>

                  <!-- Cantidad y Monto -->
                  <div class="space-y-4">
                    <!-- Cantidad -->
                    <div>
                      <label for="qty" class="mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300"
                        appRequiredLabel>
                        Cantidad
                      </label>
                      <div class="relative">
                        <input type="number" id="qty" formControlName="qty" min="1"
                          class="w-full rounded-lg border border-gray-300 bg-white px-4 py-3 text-gray-900 placeholder-gray-500 shadow-sm transition-all duration-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 dark:border-gray-600 dark:bg-gray-800 dark:text-white dark:placeholder-gray-400"
                          placeholder="1">
                        <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
                          <svg class="h-4 w-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="M7 20l4-16m2 16l4-16M6 9h14M4 15h14" />
                          </svg>
                        </div>
                      </div>
                      <div *ngIf="itemForm.get('qty')?.invalid && itemForm.get('qty')?.touched"
                        class="mt-2 flex items-center text-sm text-red-600 dark:text-red-400">
                        <svg class="mr-2 h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
                          <path fill-rule="evenodd"
                            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                            clip-rule="evenodd" />
                        </svg>
                        La cantidad debe ser al menos 1.
                      </div>
                    </div>

                    <!-- Monto Presupuestado -->
                    <div>
                      <label for="projectedAmount"
                        class="mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300" appRequiredLabel>
                        Monto Presupuestado
                      </label>
                      <div class="relative">
                        <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-4">
                          <svg class="h-5 w-5 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                          </svg>
                        </div>
                        <input type="text" appCurrencyFormatter id="projectedAmount" formControlName="projectedAmount"
                          class="w-full rounded-lg border border-gray-300 bg-white pl-12 pr-4 py-3 text-gray-900 placeholder-gray-500 shadow-sm transition-all duration-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 dark:border-gray-600 dark:bg-gray-800 dark:text-white dark:placeholder-gray-400"
                          placeholder="0">
                      </div>
                      <div *ngIf="itemForm.get('projectedAmount')?.invalid && itemForm.get('projectedAmount')?.touched"
                        class="mt-2 flex items-center text-sm text-red-600 dark:text-red-400">
                        <svg class="mr-2 h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
                          <path fill-rule="evenodd"
                            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                            clip-rule="evenodd" />
                        </svg>
                        El monto debe ser 0 o mayor.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>

          <!-- Botón para agregar presupuesto con diseño moderno -->
          <div class="text-center">
            <button type="button" (click)="addItem()"
              class="group relative inline-flex items-center justify-center px-8 py-4 overflow-hidden font-medium text-white bg-blue-600 border-2 border-blue-500 rounded-xl shadow-lg transition-all duration-300 ease-out hover:bg-blue-700 hover:border-blue-600 hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
              <svg class="relative mr-3 h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
              </svg>
              <span class="relative">Agregar Presupuesto</span>

            </button>

            <p class="mt-3 text-sm text-gray-500 dark:text-gray-400">
              Agrega tantos presupuestos como necesites para categorizar los gastos del proyecto
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- BUTTONS AREA -->
    <div
      class="mt-12 flex items-center justify-between rounded-xl border-2 border-blue-100 bg-white p-6 shadow-lg dark:border-blue-800/30 dark:bg-gray-800">
      <!-- Botón Atrás -->
      <button type="button" *ngIf="currentStep > 1" (click)="prevStep()"
        class="group relative inline-flex items-center justify-center px-6 py-3 overflow-hidden font-medium text-gray-700 bg-white border border-gray-300 rounded-lg shadow-sm transition-all duration-300 ease-out hover:bg-gray-50 hover:border-gray-400 hover:shadow-md focus:outline-none focus:ring-2 focus:ring-gray-500/20 dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 dark:hover:bg-gray-700">
        <svg class="mr-2 h-4 w-4 transition-transform duration-200 group-hover:-translate-x-1" fill="none"
          stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
        </svg>
        Atrás
      </button>

      <!-- Placeholder when no back button -->
      <div *ngIf="currentStep === 1"></div>

      <!-- Botones de acción -->
      <div class="flex space-x-4">

        <!-- Botón Siguiente -->
        <button type="button" *ngIf="currentStep !== 3" [disabled]="!isCurrentStepValid() || projectIdExists"
          (click)="nextStep()"
          class="group relative inline-flex items-center justify-center px-8 py-3 overflow-hidden font-medium text-white transition-all duration-300 ease-out focus:outline-none focus:ring-2 focus:ring-offset-2"
          [ngClass]="{
          'bg-blue-600 border-2 border-blue-500 rounded-lg shadow-lg hover:bg-blue-700 hover:border-blue-600 hover:shadow-xl focus:ring-blue-500': isCurrentStepValid() && !projectIdExists,
          'bg-gray-400 border-2 border-gray-300 rounded-lg shadow-sm cursor-not-allowed': !isCurrentStepValid() || projectIdExists
        }">

          <span class="relative flex items-center">
            Siguiente
            <svg class="ml-2 h-4 w-4 transition-transform duration-200 group-hover:translate-x-1"
              [ngClass]="{'group-hover:translate-x-1': isCurrentStepValid() && !projectIdExists}" fill="none"
              stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
            </svg>
          </span>

        </button>

        <!-- Botón Crear Proyecto -->
        <button type="submit" *ngIf="currentStep === 3" [disabled]="!isCurrentStepValid()"
          class="group relative inline-flex items-center justify-center px-10 py-3 overflow-hidden font-bold text-white transition-all duration-300 ease-out focus:outline-none focus:ring-2 focus:ring-offset-2"
          [ngClass]="{
          'bg-blue-600 border-2 border-blue-500 rounded-lg shadow-lg hover:bg-blue-700 hover:border-blue-600 hover:shadow-xl focus:ring-blue-500': isCurrentStepValid(),
          'bg-gray-400 border-2 border-gray-300 rounded-lg shadow-sm cursor-not-allowed': !isCurrentStepValid()
        }">


          <svg class="relative mr-3 h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
          </svg>
          <span class="relative">Crear Proyecto</span>

        </button>
      </div>
    </div>

  </form>
</div>

<!-- <app-shared-modal [(isOpen)]="showPreview">
  <app-preview-project [projectForm]="projectForm" [budgets]="budgets" (closeModal)="closePreview()"></app-preview-project>
</app-shared-modal> -->